import React, { useEffect, useState } from 'react';
import { Container, Card, Button, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://wfshare.wishfin.com/api';
const API_KEY = process.env.REACT_APP_API_KEY || '';

const ShareView = () => {
  const { shareId } = useParams();
  
  const [downloadUrl, setDownloadUrl] = useState('');
  const [fileName, setFileName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  useEffect(() => {
    fetchShareInfo();
  }, [shareId]);
  
  const fetchShareInfo = async () => {
    try {
      setLoading(true);
      setError('');
      
      const response = await axios.get(`${API_URL}/share/${shareId}`);
      
      setDownloadUrl(response.data.download_url);
      
      // Set file name from response
      if (response.data.file_name) {
        setFileName(response.data.file_name);
      } 
      // If no file_name in response but has file_path
      else if (response.data.file_path) {
        const name = response.data.file_path.split('/').pop();
        setFileName(name);
      } 
      // As a fallback, try to extract from URL
      else {
        try {
          const url = new URL(response.data.download_url);
          const filePath = url.searchParams.get('Key') || '';
          if (filePath) {
            const name = filePath.split('/').pop();
            setFileName(name);
          }
        } catch (e) {
          console.error("Failed to extract filename from URL:", e);
        }
      }
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Failed to load shared file';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  
  const handleDownload = () => {
    // Navigate directly to the download URL - will force download due to ResponseContentDisposition
    window.location.href = downloadUrl;
  };
  
  return (
    <Container>
      <Card className="mt-5">
        <Card.Header>
          <h4>Shared File</h4>
        </Card.Header>
        
        <Card.Body className="text-center py-5">
          {loading ? (
            <div>Loading shared file information...</div>
          ) : error ? (
            <Alert variant="danger">{error}</Alert>
          ) : (
            <>
              <h5>
                {fileName ? 
                  `The file "${fileName}" has been shared with you` : 
                  "A file has been shared with you"
                }
              </h5>
              <p className="mb-4">You can download it using the button below</p>
              
              <Button variant="primary" size="lg" onClick={handleDownload}>
                <FaDownload className="me-2" /> Download File
              </Button>
            </>
          )}
        </Card.Body>
      </Card>
      
    </Container>
  );
};

export default ShareView;
